import React from 'react';
import { Theme, withTheme, WithTheme } from '@material-ui/core/styles';
import { WithData } from './WithData';
import RosterTable from './RosterTable';
import { RosterDataGrid } from './RosterDataGrid';

interface RosterViewportProps {
    startDate: Date
}

interface RosterViewportState {
    isLgViewport: boolean;
}

class RosterViewport extends React.PureComponent<RosterViewportProps & WithTheme & WithData, RosterViewportState> {

    private readonly breakpointQuery: MediaQueryList;

    constructor(props: RosterViewportProps & WithTheme & WithData) {
        super(props);
        this.breakpointQuery = RosterViewport.createViewportBreakpointQuery(props.theme);
        this.state = { isLgViewport: this.breakpointQuery.matches };
    }

    componentDidMount() {
        this.registerBreakpointQueryListener(this.breakpointQuery);
        this.setState({ isLgViewport: this.breakpointQuery.matches });
    }

    private readonly handleBreakpointTraversal = (ev: MediaQueryListEvent) => {
        this.setState({ isLgViewport: ev.matches });
    }

    private static createViewportBreakpointQuery(theme: Theme) {
        return window.matchMedia(theme.breakpoints.up('lg').substr('@media '.length));
    }

    private registerBreakpointQueryListener(query: MediaQueryList): MediaQueryList {
        query.addEventListener("change", this.handleBreakpointTraversal);
        return query;
    }

    componentWillUnmount() {
        this.breakpointQuery.removeEventListener("change", this.handleBreakpointTraversal);
    }

    render() {
        return this.state.isLgViewport
            ? <RosterDataGrid startDate={this.props.startDate} data={this.props.data} loading={this.props.loading} />
            : <RosterTable startDate={this.props.startDate} data={this.props.data} loading={this.props.loading} />
    }
}

export default withTheme(RosterViewport);